import * as Yup from "yup";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import { useRecoilValue } from "recoil";
import { useParams } from "react-router";
import DiscountForm from "../Forms/DiscountForm";
import useStyles from "../../../../styles/styles";
import { configState } from "../../../../recoil/atoms";
import { Button, Grid, Typography } from "@mui/material";
import { CreateDiscountBody, DiscountApi } from "../../../../api/payment";

const AddPatientDiscounts = () => {
  const classes = useStyles();
  let { patientID } = useParams();
  const config = useRecoilValue(configState);

  const addPatientDiscount = (values: CreateDiscountBody, actions: any) => {
    const patientDiscount = new DiscountApi(config);
    patientDiscount
      .createDiscount(values)
      .then((res) => {
        toast.success("Discount added successfully!");
        actions.resetForm({});
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const handleSubmit = (values: CreateDiscountBody, actions: any) => {
    actions.setTouched({});
    actions.setSubmitting(false);
    addPatientDiscount({ ...values }, actions);
  };

  return (
    <>
      <Typography variant="h4" component="div" sx={{ mb: 5 }}>
        Add a discount
      </Typography>
      <Formik
        initialValues={{
          patient_id: patientID!,
          amount: 0,
          currency: "",
        }}
        enableReinitialize={true}
        validationSchema={
          Yup.object().shape({
            patient_id: Yup.string().required('Patient Name is required'),
            amount: Yup.number()
            .typeError('Amount must be a number')
            .positive('Amount must be a positive number')
            .required('Amount is required'),
            currency: Yup.string().required('Currency is required'),
          })
        }
        onSubmit={handleSubmit}
      >
        {({ dirty, isSubmitting, values }) => {          
          return (
            <Form>
              <DiscountForm />
              <Grid className={classes.buttons}>
                <Grid className={classes.wrapper}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    disabled={isSubmitting}
                  >
                    Add Discount
                  </Button>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default AddPatientDiscounts;
